import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import customAxios from "../../customAxios";
import { CREATE_DRIVER } from "../../routes";

const createDriverByAdmin = async (formData: ICreateAndUpdateDriver) => {
  try {
    return (
      await customAxios.post(CREATE_DRIVER, {
        ...formData,
        gender: formData.gender?.value,
        company: formData.company?._id,
        marital: formData.marital?.value,
        // locations ----------------------
        neighborhood: formData.neighborhood,
        province    : formData.province    ,
        area        : formData.area        ,
        city        : formData.city        ,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ CREATE_DRIVER: error });
    return false;
  }
};

export default createDriverByAdmin;
